import {useEffect} from "react";
import {VersionRequest} from "tools/webservice";
import WebConfig from "middlewares/WebConfig";

const localStorageKey = "MVersion";

const CacheBuster = () => {
  useEffect(
    () => {
      const oldVersion = localStorage.getItem(localStorageKey);
      const getVersion = async () => {
        const res = await VersionRequest();
        await res;
        res.json().then(({version: newVersion}) => {
          if(!oldVersion || oldVersion !== newVersion) {
            localStorage.setItem(localStorageKey, newVersion);
            window.location.reload(true);
          }
        });
      };
      if(WebConfig.environment !== "development")
        getVersion();
    },
    []
  );
  return null;
};

export default CacheBuster;